import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('skechers_co_line')
export class SkechersCOLineEntity {

    @PrimaryGeneratedColumn("increment", {
        name: "id",
    })
    id: number;

    @Column('varchar', {
        nullable: false,
        name: "po_number",
        length: 15
    })
    poNumber: string;

    @Column('varchar', {
        name: "po_style"
    })
    poStyle: string

    @Column('varchar', {
        name: "ex_factory_date"
    })
    exFactoryDate: string

    @Column('varchar', {
        name: "delivery_date"
    })
    deliveryDate: string

    @Column('varchar', {
        nullable: false,
        name: "color",
        length: 15
    })
    color: string;

    @Column('varchar', {
        nullable: true,
        name: "item_no", 
        length: 4
    })
    itemNo: string;

    @Column('varchar', {
        name: "price",
        length:255
    })
    price: string;

    @Column('varchar', {
        nullable: true,
        name: "co_date",
        length: 10
    })
    coDate: string;

    @Column('varchar', {
        nullable: true,
        name: "co_number",
        length: 10
    })
    coNumber: string;

    @Column('varchar', {
        nullable: true,
        name: "status",
        length: 15
    })
    status: string;

    @Column('varchar', {
        nullable: true,
        name: "error_msg",
        length: 50
    })
    errorMsg: string;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;
}